module.exports = __webpack_public_path__ + "static/img/DSC_0092.a78bb6f2.jpg";